import React from 'react'
import textServices from 'services/text-services'

const RankingItem = ({ user }: { user: any }) => {
  return (
    <div className='ranking__item'>
      <div className='ranking__item__container'>
        <div className='ranking__item__position position'>
          <h2>
            {user?.id}°
          </h2>
        </div>
        <div className='ranking__item__id'>
          <h2>
            <b>{user?.nickName}</b>
            <br />
            Id {user?.profileId}
          </h2>
        </div>
      </div>

      <div className='ranking__item__points'>
        <h2 className='ranking__item__points__number'>
          {user?.points}
        </h2>
        <h2 className='ranking__item__points__text'>
          {
            textServices.findByText('ranking/item/points', 'PUNTOS')
          }
        </h2>
      </div>
    </div>
  )
}

export default RankingItem